var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M22 2v20H2V2h20zM12 6h-2v8h6v-2h-4V6z"}));
}

Clock.defaultProps = {"width":"24","height":"24","aria-label":"clock icon","viewBox":"0 0 24 24"};

module.exports = Clock;

Clock.default = Clock;
